export const getLogo = (name: string) => require(`@wnc/ui/src/assets/demo/client-logos/${name}?url`) as string;
